import React, {ReactNode, useState} from "react";
import {observer} from "mobx-react-lite";
import Select from "react-select";
import "./searchSelection.sass";
import {GenericObservableList} from "../../../stores/observables/genericObservableList";

export interface ISearchSelectionProps<T> {
  items: GenericObservableList<T>;
  formatOptionLabel: (value: T) => React.ReactNode;
  placeholder?: string;
  isDisabled?: boolean;
  onSearch: (text: string) => void;
  optionDisable: (option: T) => boolean;
  onSelected: (option: T) => void;
  isLoading?: boolean;
  onBlur?: () => void;
  noOptionsMessage?: string;
  isOpenMenu?: boolean;
  inputId?: string;
}

const SearchSelection = <T extends object>({
  items,
  onSelected,
  onSearch,
  onBlur,
  formatOptionLabel,
  optionDisable,
  isLoading,
  noOptionsMessage = "",
  placeholder,
  isOpenMenu = false,
  inputId
}: ISearchSelectionProps<T> & {children?: ReactNode}) => {
  const [searchValue, setSearchValue] = useState("");
  return (
    <Select
      closeMenuOnSelect={true}
      maxMenuHeight={130}
      aria-label="select-edit"
      options={items.items}
      defaultValue={items.selectedItem}
      onChange={(option) => {
        if (option) onSelected(option);
        items.setSelectedItem(option ?? null);
      }}
      onInputChange={(value) => {
        onSearch(value);
        setSearchValue(value);
      }}
      inputId={inputId}
      onBlur={onBlur}
      className="search-selection"
      classNamePrefix="select"
      placeholder={placeholder}
      formatOptionLabel={formatOptionLabel}
      noOptionsMessage={() => noOptionsMessage}
      isClearable={true}
      isOptionDisabled={optionDisable}
      filterOption={() => true}
      menuPortalTarget={document.body}
      isLoading={isLoading}
      menuIsOpen={isOpenMenu && !!searchValue.length}
      autoFocus={true}
      menuPlacement="auto"
      menuShouldBlockScroll={true}
    />
  );
};

export default observer(SearchSelection);
